import dayjs from 'dayjs';
import { ALPHA_CHARACTERS_ONLY, POSTCODE, SPACES_ONLY } from 'utils/validation';
import * as yup from 'yup';

export const schema = yup.object({
  accountNumber: yup
    .string()
    .nullable()
    .required('Please enter your 8 digit mortgage account number (e.g. 12345678).')
    .min(8, 'Please enter your 8 digit mortgage account number (e.g. 12345678).')
    .max(8, 'Please enter your 8 digit mortgage account number (e.g. 12345678).'),
  dob: yup
    .string()
    .nullable()
    .required('Please enter your date of birth in the correct format (DD/MM/YYYY).')
    .test(
      'valid-date',
      'Please enter your date of birth in the correct format (DD/MM/YYYY).',
      (date) => dayjs(date, 'DD-MM-YYYY', true).isValid()
    ),
  surname: yup
    .string()
    .nullable()
    .required('Please enter your surname.')
    .max(35, 'Please enter a valid surname (max length 35 characters).')
    .matches(
      ALPHA_CHARACTERS_ONLY,
      "Please note your surname can contain letters, -, ', spaces and some symbols, so you can enter your surname in the same way as how we usually write to you."
    )
    .matches(
      SPACES_ONLY,
      "Please note your surname can contain letters, -, ', spaces and some symbols, so you can enter your surname in the same way as how we usually write to you."
    ),
  postcode: yup
    .string()
    .nullable()
    .required('Please enter the postcode of your mortgaged property.')
    .matches(
      POSTCODE,
      'Please enter a valid postcode. The postcode can contain letters, numbers and spaces only.'
    )
});
